'use client';
/**
 * Created by nicolas.looschen@pikobytes.de on 17.02.2025.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
import { Box, Typography, useTheme } from '@mui/material';
import type { ReactNode } from 'react';
import uniNeue from '../../configuration/theme/fonts/uniNeue';
import Divider from '../Divider/Divider';

export const PageSubtitle = ({ subtitle }: { subtitle: ReactNode }) => {
    const theme = useTheme();
    return (
        <Box
            sx={{
                width: 1,
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
            }}
        >
            <Box
                className="small-width"
                sx={{
                    mt: '52px',
                    '.MuiTypography-h2': {
                        fontFamily: uniNeue.style.fontFamily,
                        color: 'primary.ultraDark',
                        fontSize: '16px',
                        fontWeight: 400,
                        lineHeight: '32px',
                        textAlign: 'center',

                        [theme.breakpoints.up('lg')]: {
                            fontSize: '20px',
                        },
                    },
                }}
            >
                <Typography component="p" variant="h2">
                    {subtitle}
                </Typography>
            </Box>
            <Divider variant="section-start" />
        </Box>
    );
};
